import type {AppConfig} from "./appConfig.types";

export const appConfig: AppConfig = {
	homeLinks: undefined
};
